import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Whenever the backend rejects a premium action with detail "demo_locked",
// broadcast a global event so the mounted <LockedFeatureDialog /> pops up.
// Individual call sites can still handle the error themselves; the dialog
// is a graceful fallback that guarantees the upsell is always shown.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && detail === "demo_locked") {
      try {
        // Try to infer the blocked feature from the request URL for context.
        const url = err?.config?.url || "";
        const feature =
          url.includes("/properties/scrape") ? "Analizza Link" :
          url.includes("/properties/parse-screenshot") ? "Analisi Screenshot" :
          url.includes("/properties/import") ? "Importa Excel / CSV" :
          url.includes("/properties") ? "Creazione immobili" :
          "";
        window.dispatchEvent(new CustomEvent("demo-locked", { detail: { feature } }));
      } catch (_) { /* noop */ }
    }
    return Promise.reject(err);
  }
);

export default api;
